<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    :retain-focus="false"
    max-width="900px"
    persistent
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
        <v-spacer />
        <v-btn icon @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-tabs
          v-model="activeTab"
          background-color="primary"
          dark
          class="compact-tabs"
        >
          <v-tab class="compact-tab">
            <v-icon small class="mr-1">info</v-icon> 
            INFO
          </v-tab>
          <v-tab class="compact-tab">
            <v-icon small class="mr-1">assignment</v-icon> 
            TERMS & EVENTS
          </v-tab>
          <v-tab class="compact-tab">
            <v-icon small class="mr-1">email</v-icon> 
            COMMUNICATIONS
          </v-tab>
          <v-tab class="compact-tab">
            <v-icon small class="mr-1">tune</v-icon> 
            OTHER INFO
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="activeTab" touchless>
          <v-tab-item>
            <Person
              :editedItem="editedItem.person"
              :groupListFiltered="groupListFiltered"
              :nameRules="nameRules"
              :emailRules="emailRules"
              :phoneRules="phoneRules"
              :requiredRule="requiredRule"
              :catValueListArray="catValueListArray"
              :isFormValid.sync="isFormValid"
              :menu.sync="menu"
              :dateMenu.sync="dateMenu"
              :timeMenu.sync="timeMenu"
              :allowedTimes="allowedTimes"
            />
          </v-tab-item>
          <v-tab-item>
            <v-container>
              <ParticipationTerms
                :personId="Number(editedItem.person.personId)"
              />
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container>
              <Communications
                :leadId="editedItem.seqNo"
                :phone="editedItem.person.phone"
                :email="editedItem.person.email"
              />
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <JsonDisplay :json="editedItem.person.otherInfo || {}" />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close">Close</v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Person from "./Person.vue";
import Communications from "./PersonCommunications.vue";
import ParticipationTerms from "./ClubPersonRel.vue";
import JsonDisplay from "./JsonDisplay.vue";
import { getCatValues } from "../../../mixins/getCatValues.js";

export default {
  name: "AthleteDialog",
  
  components: {
    Person,
    Communications,
    ParticipationTerms,
    JsonDisplay,
  },
  
  mixins: [getCatValues],
  
  props: {
    value: {
      type: Boolean,
      default: false
    },
    editedItem: {
      type: Object,
      required: true
    },
    editedIndex: {
      type: Number,
      default: -1
    },
    groupListFiltered: {
      type: Array,
      default: () => []
    }
  },
  
  data() {
    return {
      activeTab: 0,
      isFormValid: true,
      menu: false,
      dateMenu: false,
      timeMenu: false,
      
      // Validation rules
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 50) || "Name must be less than 50 characters",
      ],
      requiredRule: [(v) => !!v || "Value is required"],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^(\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+)(\s*;\s*(\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+))*$/.test(
            v
          ) || "E-mail must be valid",
      ],
      phoneRules: [
        (v) => !!v || "Phone number is required",
        (v) =>
          /^\+?\d{1,3}[-\s]?\(?\d{3}\)?[-\s]?\d{3}[-\s]?\d{4}(;\s*\+?\d{1,3}[-\s]?\(?\d{3}\)?[-\s]?\d{3}[-\s]?\d{4})*$/.test(
            v
          ) || "Phone number must be valid",
      ],
      
      allowedTimes: ["17:00", "18:00", "19:00"],
    };
  },
  
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Athlete"
        : "Edit " + 
          (this.editedItem.person.firstName || "") + " " + 
          (this.editedItem.person.lastName || "");
    }
  },
  
  watch: {
    value(newVal) {
      if (!newVal) {
        this.activeTab = 0;
      }
    }
  },
  
  methods: {
    close() {
      this.$emit('close');
    },
    
    save() {
      if (!this.isFormValid) return;
      this.$emit('save', this.editedItem);
    }
  }
};
</script>

<style scoped>
.compact-tabs {
  width: 100%;
  min-width: 130px;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  padding: 0;
}

.compact-tab {
  min-height: 32px;
  font-size: 11px;
  padding: 6px 10px;
  margin: 2px 0;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  line-height: 1.2;
  transition: background 0.2s ease;
}

.compact-tab:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.compact-tab--active {
  background-color: #1976d2;
  box-shadow: inset 4px 0 0 #ffffff;
}

.v-tabs-slider {
  display: none !important;
}
</style>